import { VideoPlayer } from "@/components/ui/video-player";
import { t } from "@/lib/typography";

interface ChapterVideoSummaryProps {
  src: string;
  title: string;
}

export function ChapterVideoSummary({ src, title }: ChapterVideoSummaryProps) {
  return (
    <div className="space-y-2">
      <h2 className={t.sectionTitle}>Video Summary</h2>
      <VideoPlayer src={src} title={`${title} - Video Summary`} />
    </div>
  );
}
